/**
 * ResponsavelGrupoEconomico
 * @author Simpli CLI generator
 */
import {Request, Resource} from 'simpli-web-sdk'
import {ResponseExclude, ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {ResponsavelGrupoEconomicoCollection} from '@/model/collection/ResponsavelGrupoEconomicoCollection'

export class ResponsavelGrupoEconomico extends Resource {
  @ResponseSerialize(Responsavel)
  responsavelMaster: Responsavel | null = null

  @ResponseSerialize(Responsavel)
  responsavelPermitido: Responsavel | null = null

  idResponsavelMasterFk: number | null = null
  idResponsavelPermitidoFk: number | null = null
  dataCriacao: string | null = null

  visualizacaoEmbarcador: boolean = true
  visualizacaoTransportador: boolean = true

  @ResponseExclude()
  senha: string | null = null

  get $id() {
    if (!this.responsavelPermitido) return 0
    return this.responsavelPermitido?.$id
  }
  set $id(val) {
    if (!this.responsavelPermitido)
      this.responsavelPermitido = new Responsavel()
    this.responsavelPermitido.$id = val
  }

  reset() {
    this.responsavelMaster = null
    this.responsavelPermitido = null
    this.idResponsavelMasterFk = 0
    this.idResponsavelPermitidoFk = 0
    this.senha = null
  }

  /**
   * Gets a instance of a given ID of ResponsavelGrupoEconomico
   */
  async getResponsavelGrupoEconomico(id1: number, id2: number) {
    return await Request.get(`/admin/responsavel-grupo-economico/${id1}/${id2}`)
      .name('getResponsavelGrupoEconomico')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of ResponsavelGrupoEconomico
   */
  static async listIdsGrupoEconomico() {
    return await Request.get(`/admin/responsavel-grupo-economico/list-ids`)
      .name('listIdsResponsaveis')
      .asArrayOf(ResponsavelGrupoEconomico)
      .getData()
  }

  /**
   * Persists a new instance of ResponsavelGrupoEconomico. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistResponsavelGrupoEconomico() {
    return await Request.post(`/admin/responsavel-grupo-economico`, this)
      .name('persistResponsavelGrupoEconomico')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ResponsavelGrupoEconomico to use it in a CSV file
   */
  static async listCsvResponsavelGrupoEconomico(params: any) {
    return await Request.get(`/admin/responsavel-grupo-economico/csv`, {params})
      .name('listCsvResponsavelGrupoEconomico')
      .as(ResponsavelGrupoEconomicoCollection)
      .getData()
  }

  /**
   * Lists the instances of ResponsavelGrupoEconomico to use it in a CSV file
   */
  async persistSenhaMasterGrupoEconomico(idResponsavel: number, model: string) {
    return await Request.post(
      `/admin/responsavel-grupo-economico/senha-master/${idResponsavel}`,
      {model}
    )
      .name('persistSenhaMasterGrupoEconomico')
      .asNumber()
      .getData()
  }

  async persistVisaoGrupoEconomico(
    idResponsavel: number,
    model: ResponsavelGrupoEconomico
  ) {
    return await Request.post(
      `/admin/responsavel-grupo-economico/visao/${idResponsavel}`,
      {model}
    )
      .name('persistVisualizacaoGrupoEconomico')
      .asNumber()
      .getData()
  }
}
